module.exports = __webpack_public_path__ + "static/beshaba-DND3_FnP-1b43dbd2588d8acb711101fce7acb6a9.jpg";